export default {
  translation: {
    regionPicker: {
      chooseArea: '请选择您的地区'
    },
    configurator: {
      configureNow: 'Configure my handle !',
      chooseFrameColor: '请选择您的边框颜色',
      chooseHandle: '请选择您想要配置的样式',
      createYourOwnButton: '定制我的把手',
      createYourOwn: '下载文件',
      sendConfig: '保存这个执手',
      colorType: {
        ral: '喷漆',
        anodized: '阳极氧化',
        decor: '装饰性的',
        custom: '定制化'
      },
      color: {
        black: '黑色',
        white: '白色'
      },
      form: {
        myConfig: '保存你的定制执手',
        send: '发送！',
        success: '你的配置已经成功通过邮件发送',
        error: '邮件发送时发生错误',
        model: '执手模型',
        color: '颜色',
        ornament: '装饰',
        ornament_color: '装饰的色系',
        custom: '自定义装饰'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/i18n/cn.js